const ContentSlider = function (target, settings) {

    let sliderElement = target;
    let activeView = 1;
    let slidesCountPerActiveView = 1;
    let slideWidthInActiveView;
    let allSlidesCount;
    let timer;
    let translate;

    let defaultSettings = {
        maxHeight: "90vh",
        enableDots: true,
        enableArrows: true,
        enableAutoStart: true,
        duration: 5000,
        slidesCountPerView: 1,
        viewSlideWidth: null,
        slidesGap: 0,
        nthViewVisible: (index, slides) => {
        }
    };

    parseOptions(defaultSettings, settings);

    Object.defineProperties(this, {
        sliderElement: {
            get: function () {
                return sliderElement;
            }
        },
        maxHeight: {
            get: function () {
                return defaultSettings.maxHeight;
            },
            set: function (maxH) {
                defaultSettings.maxHeight = maxH;
            }
        },
        enableDots: {
            get: function () {
                return defaultSettings.enableDots;
            },
            set: function (enableDost) {
                if (isBoolean(enableDost)) {
                    defaultSettings.enableDots = enableDost;
                }
            }
        },
        enableArrows: {
            get: function () {
                return defaultSettings.enableArrows;
            },
            set: function (enableArrows) {
                if (isBoolean(enableArrows)) {
                    defaultSettings.enableArrows = enableArrows;
                }
            }
        },
        enableAutoStart: {
            get: function () {
                return defaultSettings.enableAutoStart;
            },
            set: function (enableAutostart) {
                if (isBoolean(enableAutostart)) {
                    defaultSettings.enableAutostart = enableAutostart;
                }
            }
        },
        duration: {
            get: function () {
                return defaultSettings.duration;
            },
            set: function (duration) {
                if (isNumeric(duration)) {
                    defaultSettings.duration = duration;
                }
            }
        },
        slidesCountPerView: {
            get: function () {
                return defaultSettings.slidesCountPerView;
            },
            set: function (slidesCountPerView) {
                defaultSettings.slidesCountPerView = slidesCountPerView;
            }
        },
        viewSlideWidth: {
            get: function () {
                return defaultSettings.viewSlideWidth;
            },
            set: function (width) {
                defaultSettings.viewSlideWidth = width;
            }
        },
        slidesGap: {
            get: function () {
                return defaultSettings.slidesGap;
            },
            set: function (slidesGap) {
                defaultSettings.slidesGap = slidesGap;
            }
        },
        nthSlideVisible: {
            get: function () {
                return defaultSettings.nthSlideVisible;
            },
            set: function (nthSlideVisible) {
                if (isFunction(nthSlideVisible)) {
                    defaultSettings.nthSlideVisible = nthSlideVisible;
                }
            }
        },
        activeView: {
            get: function () {
                return activeView;
            },
            set: function (view) {
                if (isNumeric(view)) {
                    activeView = view;
                }
            }
        },
        slidesCountPerActiveView: {
            get: function () {
                return slidesCountPerActiveView;
            },
            set: function (num) {
                if (isNumeric(num)) {
                    slidesCountPerActiveView = num;
                }
            }
        },
        slideWidthInActiveView: {
            get: function () {
                return slideWidthInActiveView;
            },
            set: function (num) {
                if (isNumeric(num)) {
                    slideWidthInActiveView = num;
                }
            }
        },
        timer: {
            get: function () {
                return timer;
            },
            set: function (newTimer) {
                timer = newTimer;
            }
        },
        translate: {
            get: function () {
                return translate;
            },
            set: function (tr) {
                if (isNumeric(tr)) {
                    translate = tr;
                }
            }
        },
        allSlidesCount: {
            get: function () {
                return allSlidesCount;
            },
            set: function (count) {
                if (isNumeric(count)) {
                    allSlidesCount = count;
                }
            }
        },
    });

};

ContentSlider.prototype.getBody = function () {
    return this.sliderElement.find('.slider-body');
};

ContentSlider.prototype.getContent = function () {
    return this.sliderElement.find('.slider-content');
};

ContentSlider.prototype.getSlides = function () {
    return this.getContent().find('.slider-slide');
};

ContentSlider.prototype.getArrows = function () {
    return this.sliderElement.find('.slider-buttons');
};

ContentSlider.prototype.getDots = function () {
    return this.sliderElement.find('.slider-pagination-wrap .slider-pagination');
};

ContentSlider.prototype.setSliderTranslate = function () {
    this.getContent().css("transform", "translateX(" + this.translate + "px)");
};

ContentSlider.prototype.checkArrows = function () {

    let arrows = this.getArrows();
    let prevArrow = arrows.find('.slider-prev');
    let nextArrow = arrows.find('.slider-next');

    if (this.activeView === 1) {
        prevArrow.hide();
    } else {
        prevArrow.show();
    }
    if (this.activeView * this.slidesCountPerActiveView < this.allSlidesCount) {
        nextArrow.show();
    } else {
        nextArrow.hide();
    }

};

ContentSlider.prototype.checkSlideWidth = function () {

    let singleSlideWidth;
    if (this.viewSlideWidth != null) {

        if (isFunction(this.viewSlideWidth)) {
            singleSlideWidth = this.viewSlideWidth(this.sliderElement.outerWidth(), this.slidesGap);
        } else {
            singleSlideWidth = this.viewSlideWidth;
        }

    } else {

        if (isFunction(this.slidesCountPerView)) {
            singleSlideWidth = (this.sliderElement.outerWidth() - (this.slidesGap * this.slidesCountPerView())) / this.slidesCountPerView();
        } else {
            singleSlideWidth = (this.sliderElement.outerWidth() - (this.slidesGap * this.slidesCountPerView)) / this.slidesCountPerView;
        }

    }

    this.slideWidthInActiveView = singleSlideWidth;

    let slides = this.getSlides();
    slides.css({"flex-basis": "" + singleSlideWidth + "px"});

    slides.not(':first').css("margin-left", this.slidesGap + 'px');

};

ContentSlider.prototype.checkSlidesCountPerView = function () {

    if (this.viewSlideWidth != null) {
        let sliderWidth = this.sliderElement.outerWidth() - this.slidesGap;
        this.slidesCountPerActiveView = Math.floor(sliderWidth / this.slideWidthInActiveView);
    } else {
        if (isFunction(this.slidesCountPerView)) {
            this.slidesCountPerActiveView = this.slidesCountPerView();
        } else {
            this.slidesCountPerActiveView = this.slidesCountPerView;
        }
    }

};

ContentSlider.prototype.moveToView = function (index) {

    if (((index * this.slidesCountPerActiveView) > this.allSlidesCount && (index - 1) * this.slidesCountPerActiveView >= this.allSlidesCount) || (index * this.slidesCountPerActiveView) < 0) {
        return false;
    }

    let slides = this.getSlides();
    let slideWidth = slides.first().outerWidth() * this.slidesCountPerActiveView;

    if (this.slidesGap > 0 && this.slidesCountPerActiveView > 1) {
        slideWidth += this.slidesCountPerActiveView * this.slidesGap;
    }

    this.activeView = index;
    this.translate = -1 * (slideWidth * (this.activeView - 1));
    this.setSliderTranslate();

    slides.removeClass('active');

    for (let i = ((this.activeView - 1) * this.slidesCountPerActiveView); i < (((this.activeView - 1) * this.slidesCountPerActiveView) + this.slidesCountPerActiveView); i++) {
        slides.eq(i).addClass('active');
    }

    this.timer = setTimeout(function () {
        //slidesLoaded(slidesPerSlideNum);
    }, 1000);

    this.checkArrows();

    /*
    if(isDefined(sliderViewsTexts)){

        let activeSliderViewTextIndex = null;

        for(const [i,v] of sliderViewsRules.entries()) {

            if ($(window).width() <= 480) {
                if (isDefined(v.mobile) && v.mobile.includes(activeView)) {
                    activeSliderViewTextIndex = i;
                    break;
                } else {
                    if(v.default.includes(activeView)) {
                        activeSliderViewTextIndex = i;
                        break;
                    }
                }
            } else if ($(window).width() <= 768) {
                if (isDefined(v.tablet) && v.tablet.includes(activeView)) {
                    activeSliderViewTextIndex = i;
                    break;
                } else {
                    if(v.default.includes(activeView)) {
                        activeSliderViewTextIndex = i;
                        break;
                    }
                }
            } else {
                if (isDefined(v.desktop) && v.desktop.includes(activeView)) {
                    activeSliderViewTextIndex = i;
                    break;
                } else {
                    if(v.default.includes(activeView)) {
                        activeSliderViewTextIndex = i;
                        break;
                    }
                }
            }

        }

        sliderViewsTexts.find(".slider-view-text").removeClass('active').eq(activeSliderViewTextIndex).addClass("active");

    }
    */

    if (this.getDots().length) {
        let dots = this.getDots();
        dots.find('li a').removeClass('active');
        dots.find('li').eq(this.activeView - 1).find('a').addClass('active');
    }

    return true;

};

ContentSlider.prototype.startTimer = function () {

    let newRepeat = false;
    let self = this;
    this.timer = setInterval(() => {
        let result = true;
        if (newRepeat) {
            newRepeat = false;
            result = self.moveToView(this.activeView);
        } else {
            result = self.moveToView(this.activeView + 1);
        }
        if (!result) {
            self.activeView = 1;
            self.moveToView(self.activeView);
        }
        if (self.activeView * self.slidesCountPerActiveView >= self.allSlidesCount) {
            self.activeView = 1;
            newRepeat = true;
        }
    }, this.duration);

};

ContentSlider.prototype.clearTimer = function () {
    clearInterval(this.timer);
    this.startTimer();
};

ContentSlider.prototype.init = function () {

    if (isDefined(this.sliderElement.data('initialized'))) {
        return false;
    }

    let self = this;
    this.sliderElement.css('max-height', this.maxHeight);
    this.allSlidesCount = this.getSlides().length;

    this.checkSlideWidth();
    this.checkSlidesCountPerView();

    if (this.enableArrows) {

        this.checkArrows();
        let arrows = this.getArrows();

        console.log(arrows);
        console.log(arrows.find('.slider-prev'));
        console.log(arrows.find('.slider-next'));

        arrows.find('.slider-prev').on('click', function (e) {
            e.preventDefault();
            self.moveToView(self.activeView - 1);
            if (self.enableAutoStart) {
                self.clearTimer();
            }
        });

        arrows.find('.slider-next').on('click', function (e) {
            e.preventDefault();
            self.moveToView(self.activeView + 1);
            if (self.enableAutoStart) {
                self.clearTimer();
            }
        });

    }

    if (this.enableDots) {

        this.sliderElement.append('<div class="slider-pagination-wrap"><ul class="slider-pagination"></ul></div>');
        let dots = this.getDots();

        let j = 1;
        for (let i = 1; i <= this.allSlidesCount; i += this.slidesCountPerActiveView) {
            dots.append(`<li><a href="#" ${i === 1 ? 'class="active"' : ""} data-view="${j}">${j}</a></li>`);
            j++;
        }

        dots.on('click', "a", function (e) {
            e.preventDefault();
            self.moveToView($(this).data("view"));
            $(this).addClass("active");
            $(this).parent().siblings().find("a").removeClass("active");
            if (self.enableAutoStart) {
                self.clearTimer();
            }
        });

    }

    this.moveToView(this.activeView);

    if (this.enableAutoStart) {
        this.startTimer();
    }

    /*wrapper.on("mouseover", function () {
        wrapper.attr("tabindex", -1).trigger("focus");
    });*/

    this.sliderElement.on("mouseleave", function () {
        self.sliderElement.trigger("blur");
    });

    this.sliderElement.on("keydown", function (e) {
        let code = e.which;
        if (code === 39) {
            self.moveToView(self.activeView + 1);
            self.clearTimer();
        }
        if (code === 37) {
            self.moveToView(self.activeView - 1);
            self.clearTimer();
        }
    });

    $(window).on("resize", function () {
        self.checkSlideWidth();
        self.checkSlidesCountPerView();
        self.moveToView(self.activeView);
    });

};